<template>
  <div class="conf">
    <div class="fongsaig">
      <img :src="image" width="753.9px" height="413.25px" />
      <div class="font">无法访问此网站</div>
      <div class="navtobtn" @click="navtoback" >跳转首页</div>
    </div>

  </div>
</template>

<script>
  import image from '@/assets/images/404.png'
  export default {
    name: "",
    data() {
      return {
        image
      }
    },
    mounted() {
      this.$store.state.spinShow = false;
    },
    methods:{
      navtoback(){
        this.$router.push({path:"/"})
      }
    }
  }
</script>

<style scoped>
  .conf {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .font {
    font-size: 42px;

    font-weight: 600;
    color: #0044A0;
    margin-top: 52px
  }

  .fongsaig {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .navtobtn {
    width: 164px;
    height: 54px;
    background: #0044A0;
    opacity: 1;
    font-size: 19px;

    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 54px;
    border-radius: 29px;
    margin-top: 42px;
    cursor: pointer;
    box-shadow: 1px 10px 5px #888888;
  }
</style>